import { HeroLabel } from '../../ds';
import type { UcHeroSection } from '../../../lib/useCaseQueries';
import { UseCaseCtaButton } from '../UseCaseCtaButton';
import { UseCaseChipRow, UseCaseMedia } from '../primitives';

type UcHeroSectionProps = {
  data: UcHeroSection;
};

export function UcHeroSection({ data }: UcHeroSectionProps) {
  const mediaAlt = data.image?.alt ?? data.headingMain ?? 'Use case hero image';

  return (
    <header className="fm-hero band-dark">
      <div className="container uc-hero-inner">
        <div className="uc-hero-text reveal">
          {data.eyebrow && <HeroLabel>{data.eyebrow}</HeroLabel>}
          {(data.headingMain || data.headingAccent) && (
            <h1 className="hero-headline">
              {data.headingMain}
              {data.headingAccent && (
                <>
                  {data.headingMain ? ' ' : null}
                  <em>{data.headingAccent}</em>
                </>
              )}
            </h1>
          )}
          {data.body && <p className="hero-sub">{data.body}</p>}
          <UseCaseChipRow chips={data.chips} />
          {(data.primaryCtaLabel && data.primaryCtaUrl) ||
          (data.secondaryCtaLabel && data.secondaryCtaUrl) ? (
            <div className="hero-ctas">
              {data.primaryCtaLabel && data.primaryCtaUrl && (
                <UseCaseCtaButton
                  label={data.primaryCtaLabel}
                  url={data.primaryCtaUrl}
                  variant="primary"
                />
              )}
              {data.secondaryCtaLabel && data.secondaryCtaUrl && (
                <UseCaseCtaButton
                  label={data.secondaryCtaLabel}
                  url={data.secondaryCtaUrl}
                  variant="ghost"
                />
              )}
            </div>
          ) : null}
          {data.footnote && <div className="hero-note">{data.footnote}</div>}
        </div>
        <div className="uc-hero-still reveal d2" role="img" aria-label={mediaAlt}>
          {data.image ? (
            <UseCaseMedia
              image={data.image}
              alt={mediaAlt}
              sizes="(max-width: 768px) 100vw, min(1100px, 100vw)"
              className="h-full w-full object-cover"
            />
          ) : (
            <div className="uc-hero-placeholder" aria-hidden="true" />
          )}
        </div>
      </div>
    </header>
  );
}
